<template>
    <div class="tag-frame">
        <div class="tag-row">
            <tag-item 
                v-for="(item, index) in tagList"
                :key="index"
                :active="item.active"
                :title="item.title"
                :noclose="item.noclose"
                @close="popTagByIndex(index)"
                @click="shiftTagByIndex(index)"
                :click="item.click"
            ></tag-item>
        </div>

        <div class="frame-con">
            <template
            v-for="(item, index) in tagList"
            >
                <frame-item 
                    ref="frame"
                    :key="index"
                    v-if="item.active"
                    :type="item.type" 
                    :src="item.src"
                ></frame-item>
            </template>
        </div>
    </div>
</template>

<script>
import TagItem from './components/tag-item';
import FrameItem from './components/frame-item';

export default {
    components: {
        TagItem,
        FrameItem,
    },
    data() {
        return {
            tagList: [],

            historyTagList: [],
        };
    },
    methods: {
        // 追加标签页
        pushTag(obj) {
            var newItem = {
                title: '',                  // 标题
                src: '',                    // 地址
                active: true,               // 激活
                noclose: false,             // 不展示关闭
                type: 'hash',               // src类型，hash或href
                id: new Date().getTime(),   // 唯一id
                topparent: false,           // 顶级导航，用于判断是否不新开tag
                click: false,               // 点击后执行的方法
                nostore: false,             // 不计入缓存
                sort: 0,                    // 排序值
                special: false,             // 特殊标记
            };
            
            //如果当前页面已被打开，且为激活状态，则刷新一次；如果已经发生了跳转，则返回src首页；
            if (this.tagList.some((item, index) => {
                return (
                    item.src === obj.src
                    && item.active
                );
            })) {
                var refFrame = this.$refs.frame[0];

                if (refFrame.isInSrcPage()) {
                    // 仅刷新页面
                    refFrame.reload();
                } else {
                    // 跳转到首页
                    refFrame.backSrc();
                }

                return;
            }

            // 混入默认配置
            mixin(obj, newItem, true);

            if (newItem.active) {
            // 如果为默认需要激活的，则需要将其他标签设为非激活的
                this.tagList.forEach(item => {
                    item.active = false;
                });
            }

            //如果当前页面已被在列队中，且未被激活，则直接将激活状态赋给它
            var setActiveIndex = 0;

            if (this.tagList.some((item, index) => {
                setActiveIndex = index;

                return (
                    (
                        item.src === obj.src
                        || item.id === obj.id
                    )
                    && !item.active
                );
            })) {
                var currentTagInList = this.tagList[setActiveIndex];
                currentTagInList.active = true;

                this._updateTagListItem(setActiveIndex, currentTagInList);

                return;
            }
            
            // 同一父级菜单的，不再打开新tag
            var spliceIndex = 0;

            if (this.tagList.some((item, index) => {
                spliceIndex = index;

                return (
                    item.topparent !== false 
                    && item.topparent === newItem.topparent
                );
            })) {
                this._updateTagListItem(spliceIndex, newItem);
            } else {
                this.tagList.push(newItem);
            }

            // 排序
            this.tagList.sort((a, b) => {
                return a.sort - b.sort;
            })

            if (!newItem.nostore) {
                this._storeTag();
            }

            return newItem;
        },
        // 根据索引清掉标签
        popTagByIndex(index) {
            var popItem = this.tagList[index],
                popItemPre = this.tagList[index - 1],
                popItemPost = this.tagList[index + 1];

            if (popItem.active) {
                if (popItemPost && !popItemPost.special) {
                    popItemPost.active = true;
                    this.$emit('shift', popItemPost);
                } else if (popItemPre) {
                    popItemPre.active = true;
                    this.$emit('shift', popItemPre);
                }
            }

            this.tagList.splice(index, 1);

            if (!popItem.nostore) {
                this._storeTag();
            }

            return this.tagList.filter(item => item.active)[0];
        },
        // 根据索引切换标签
        shiftTagByIndex(index) {
            var shiftTag = this.tagList[index];

            this.tagList.forEach(item => {
                item.active = false;
            });

            shiftTag.active = true;

            this.tagList.splice(index, 1, shiftTag);

            if (!shiftTag.nostore) {
                this._storeTag();
            }

            this.$emit('shift', shiftTag);

            return shiftTag;
        },
        // 获取当前正在激活中的项
        getActiveTag() {
            var index = 0,
                data = {};

            data = this.tagList.filter((item, i) => {
                if (item.active) {
                    index = i;
                }
                return item.active;
            })[0];

            return {
                index,
                data,
            };
        },
        // 缓存当前打开的标签页
        _storeTag() {
            var tagStore = this.tagList.filter(item => {
                return !item.nostore;
            }),
                userid = this.getGetters('user').userId;

            setLocal({
                [`tag-store-${userid}`]: tagStore,
            });
        },
        // 获取缓存中的tag数据，并生成‘恢复’按钮
        _getHistoryTag() {
            var userid = this.getGetters('user').userId,
                tagStore = getLocal(`tag-store-${userid}`);

            if (tagStore && tagStore.length > 1) {
                this.historyTagList = tagStore;

                this.pushTag({
                    title: '恢复上次打开页面',
                    active: false,
                    nostore: true,
                    click: () => {
                        this.tagList = tagStore;

                        // 同步导航中的选中状态
                        this.$emit('shift', tagStore.filter(item => item.active)[0]);
                    },
                    sort: 999,
                    special: 'reopen',
                });
            }
        },
        _updateTagListItem(index, newVal) {
            var oldVal = this.tagList[index];
            newVal.noclose = oldVal.noclose;

            this.tagList.splice(index, 1, newVal);
        },
    },
    created() {
        window.$tagFrame = {
            pushTag: this.pushTag,
            popTagByIndex: this.popTagByIndex,
            shiftTagByIndex: this.shiftTagByIndex,
            getActiveTag: this.getActiveTag,
        };
        this._getHistoryTag();
    },
    mounted() {
        // this.pushTag({
        //     title: '首页',
        //     src: '/bidding/workbench/index',
        //     noclose: true,
        // });

        // setTimeout(() => {

        //     this.pushTag({
        //         title: '公开招标',
        //         src: '/bidding/project/zfcg/list?type=2',
        //     });
        // }, 3000);

        // setTimeout(() => {

        //     this.pushTag({
        //         title: '项目管理',
        //         src: '/bidding/project/list',
        //     });
        // }, 4000);
    },
    beforeDestroy() {
        window.$tagFrame = false;
    },
};
</script>

<style lang="scss" scoped>
    .tag-frame{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;

        .tag-row{
            padding: 18px 24px;
            height: 32px;
            white-space: nowrap;
            overflow-x: auto;
            overflow-y: hidden;
        }

        .frame-con{
            height: calc(100% - 78px);
            background: #F0F2F5;
            position: relative;
            padding: 5px 10px;
        }
        .frame-item{ background-color: #fff; }
    }
</style>